// 액션 타입 정의
const FULL_CARD_SLIDER_PAGE = 'FULL_CARD_SLIDER_PAGE';
const PAGES_RESET = 'PAGES_RESET';
const HALF_TOP_IMAGE_PAGE = 'HALF_TOP_IMAGE_PAGE';
const MODAL_SLIDE_PAGE = 'MODAL_SLIDE_PAGE';
const FULL_DUAL_IMAGE_PAGE = 'FULL_DUAL_IMAGE_PAGE';
const MODAL_SLICK_PAGE = 'MODAL_SLICK_PAGE';
const FULL_SURVEY_PAGE = 'FULL_SURVEY_PAGE';
const MODAL_IMAGE_PAGE = 'MODAL_IMAGE_PAGE';
const MODAL_TOP_PAGE = 'MODAL_TOP_PAGE';
const HALF_SLIDE_UP_IMGS_PAGE = 'HALF_SLIDE_UP_IMGS_PAGE';
const NPS_MODAL_DIAL = 'NPS_MODAL_DIAL';

// 액션 생섬함수 정의
export const pagesReset = () => ({ type: PAGES_RESET });
export const fullCardSliderPage = fullCardSliderPage => ({
  type: FULL_CARD_SLIDER_PAGE,
  fullCardSliderPage
});
export const halfTopImagePage = halfTopImagePage => ({
  type: HALF_TOP_IMAGE_PAGE,
  halfTopImagePage
});

export const modalSlidePage = modalSlidePage => ({
  type: MODAL_SLIDE_PAGE,
  modalSlidePage
});

export const fullDualImagePage = fullDualImagePage => ({
  type: FULL_DUAL_IMAGE_PAGE,
  fullDualImagePage
});

export const modalSlickPage = modalSlickPage => ({
  type: MODAL_SLICK_PAGE,
  modalSlickPage
});

export const fullSurveyPage = fullSurveyPage => ({
  type: FULL_SURVEY_PAGE,
  fullSurveyPage
});

export const modalImagePage = modalImagePage => ({
  type: MODAL_IMAGE_PAGE,
  modalImagePage
});

export const modalTopPage = modalTopPage => ({
  type: MODAL_TOP_PAGE,
  modalTopPage
});

export const halfSlideUpImgsPage = halfSlideUpImgsPage => ({
  type: HALF_SLIDE_UP_IMGS_PAGE,
  halfSlideUpImgsPage
});

export const npsModalDialPage = npsModalDialPage => ({
  type: NPS_MODAL_DIAL,
  npsModalDialPage
});

// 초기상태 정의
const initialState = {
  fullCardSliderPage: 0,
  halfTopImagePage: 0,
  modalSlidePage: 0,
  fullDualImagePage: 0,
  modalSlickPage: 0,
  fullSurveyPage: 0,
  modalImagePage: 0,
  modalTopPage: 0,
  halfSlideUpImgsPage: 0,
  npsModalDialPage: 0
};

// 리듀서 작성
export default function pageReducer(state = initialState, action) {
  switch (action.type) {
    case PAGES_RESET:
      return initialState;
    case FULL_CARD_SLIDER_PAGE:
      return {
        ...state,
        fullCardSliderPage: action.fullCardSliderPage
      };
    case HALF_TOP_IMAGE_PAGE:
      return {
        ...state,
        halfTopImagePage: action.halfTopImagePage
      };
    case MODAL_SLIDE_PAGE:
      return {
        ...state,
        modalSlidePage: action.modalSlidePage
      };
    case FULL_DUAL_IMAGE_PAGE:
      return {
        ...state,
        fullDualImagePage: action.fullDualImagePage
      };
    case MODAL_SLICK_PAGE:
      return {
        ...state,
        modalSlickPage: action.modalSlickPage
      };
    case FULL_SURVEY_PAGE:
      return {
        ...state,
        fullSurveyPage: action.fullSurveyPage
      };
    case MODAL_IMAGE_PAGE:
      return {
        ...state,
        modalImagePage: action.modalImagePage
      };
    case MODAL_TOP_PAGE:
      return {
        ...state,
        modalTopPage: action.modalTopPage
      };
    case HALF_SLIDE_UP_IMGS_PAGE:
      return {
        ...state,
        halfSlideUpImgsPage: action.halfSlideUpImgsPage
      };
    case NPS_MODAL_DIAL:
      return {
        ...state,
        npsModalDialPage: action.npsModalDialPage
      };
    default:
      return state;
  }
}
